import type {
  CatalogProduct,
  CatalogSelection,
  CatalogVariant,
  ShoppingRecommendations,
} from "@/types/shoppingCatalog.ts";

export function shoppingImages(product: CatalogProduct, variant?: CatalogVariant) {
  const seen = new Set<string>();
  return [...(variant?.images ?? []), ...product.images].filter((image) => {
    if (seen.has(image.url)) return false;
    seen.add(image.url);
    return true;
  });
}

export function shoppingDescriptionSummary(description: string) {
  if (description.length <= 280) return description;
  const prefix = description.slice(0, 280);
  return `${prefix.slice(0, prefix.lastIndexOf(" ") > 0 ? prefix.lastIndexOf(" ") : 280)}…`;
}

export function shoppingCheckoutHint(
  selection: CatalogSelection | undefined,
  variant: CatalogVariant | undefined,
  status: "pending" | "error" | "success",
) {
  if (!selection) return "Choose a product to review checkout.";
  if (status === "pending") return "Loading details before checkout…";
  if (status === "error") return "Retry product details to continue.";
  if (!variant) return "Choose an available option before checkout.";
  if (!variant.available) return "This option is out of stock.";
  return "You’ll review the final total before approving payment.";
}

export type ShoppingRecommendationProps = {
  recommendations: ShoppingRecommendations;
  products: CatalogProduct[];
  canBuy: boolean;
  pending: boolean;
  onPrepare: (option: number) => void;
  onDetails: (selection: CatalogSelection) => void;
};

export function shoppingRecommendationRows(
  recommendations: ShoppingRecommendations,
  products: CatalogProduct[],
) {
  return recommendations.options.map((option, index) => {
    const product = products.find((item) => item.id === option.selection.productId);
    const variant = product?.variants.find((item) => item.id === option.selection.variantId);
    return {
      ...option,
      number: index + 1,
      label: index === 0 ? "My pick" : "Alternative",
      product,
      variant,
      image: variant?.images[0] ?? product?.images[0],
      changed: option.changed || !variant?.available,
    };
  });
}
